module.exports = __webpack_public_path__ + "img/stationarity-tool.97553748.png";